export default "__VITE_ASSET__Bm2V5qc4__"